import React from 'react';
import { ModalReceiverProps } from '../../../../../../app/layout/Modals/ModalManager';
import SubmitCancelModalUI from '@cube3/ui/src/Layout/AccountSettings/Modals/SubmitCancelModalUI';
import { useModalActions } from '../../../../../layout/Modals/modalActions';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { Field } from '@cube3/forms/src/types/GenericFormTypes';
import { Typography } from '@cube3/ui/src/typography/Typography';
import SupportEmailComponent from '@cube3/ui/src/Email/SupportEmailComponent';
import { GenericReduxForm } from '@cube3/forms/src/forms/GenericReduxForm';

interface Props extends ModalReceiverProps {
  onSave(values: any): void;
  loading: boolean;
  config: {
    fields: (Field & { extraProps?: any })[];
  };
  title?: string;
  failed?: boolean;
}

export const EditSettingModalBase: React.FC<
  Props & InjectedFormProps<{}, Props>
> = (props) => {
  const {
    valid,
    submitting,
    handleSubmit,
    title = 'Edit setting',
    config,
    loading,
    error,
    pristine
  } = props;

  const { previousModal } = useModalActions();

  return (
    <SubmitCancelModalUI
      title={title}
      onCloseEvent={previousModal}
      submitDisabled={!valid || submitting}
      submitReplaced={pristine}
      onSubmit={handleSubmit}
      loading={loading || submitting}
    >
      <GenericReduxForm
        fields={config.fields}
        colorVariant="02"
        weight="body"
        direction="vertical"
      />
      {error && (
        <div style={{ padding: 8 }}>
          <Typography color="danger1">
            Something went wrong with your request, please try again later or
            contact <SupportEmailComponent />
            ...
          </Typography>
        </div>
      )}
    </SubmitCancelModalUI>
  );
};

export const EditSettingModal = reduxForm<{}, Props>({
  onSubmit: (values, dispatch, props) => {
    props.onSave(values);
  }
})(EditSettingModalBase);
